import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CheckboxModel } from '../../model/checkbox.model';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
    @Input() text: string;
    @Input() icon: string;
    @Input() idName: string;
    @Input() checked: boolean = false;
    @Input() disabled: boolean = false;
    @Input() index: number = 0;

    @Output() changed: EventEmitter<CheckboxModel> = new EventEmitter<CheckboxModel>();

    constructor(private globalService: GlobalService) { }

    ngOnInit() { }

    onChange() {
        if (!this.disabled) {
            let checkboxModel: CheckboxModel = {
                id: this.idName,
                checked: this.checked
            }
            this.changed.emit(checkboxModel);
        }
        else {
            this.checked = false;
        }
    }

    isMobile(){
        return this.globalService.isMobile;
    }

    isDisabled() {
        return this.disabled ? 'disabled' : null;
    }

    onKeydown($event) {
        if ($event.keyCode === 32) {
            $event.preventDefault();
        }

        if (this.globalService.isFirefox()) {
            if ($event.keyCode === 32) {
                $event.currentTarget.click();
            }
            else if ($event.keyCode === 13) {
                $event.currentTarget.children[2].click();
            }
        }
        else {
            if ($event.keyCode === 13 || $event.keyCode === 32) {
                $event.currentTarget.children[2].click();
            }
        }
    }
}
